import { render, staticRenderFns } from "./yuxiangProductReport.vue?vue&type=template&id=4f2b582c&"
import script from "./yuxiangProductReport.vue?vue&type=script&lang=js&"
export * from "./yuxiangProductReport.vue?vue&type=script&lang=js&"
import style0 from "./yuxiangProductReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports